<template>
  <div class="login">
    <b-container>
      <h2 class="section-heading">Recruitment Portal</h2>
      <b-row>
        <b-col>
          <div class="login-card">
            <b-form>
              <!-- Username -->
              <label class="input-label">Email</label>
              <b-form-group
              >
                <b-form-input
                  type="email"
                  
                  v-model="$v.user.email.$model"
                ></b-form-input>
              </b-form-group>
              <!-- Password -->
              <label class="input-label">Password</label>
              <b-input-group
              >
                <b-form-input
                 
                  v-model="$v.user.password.$model"
                  :type="passwordType"
                  class="password-input"
                ></b-form-input>
                <b-input-group-prepend 
                is-text
                @click="toggleShowPassword()"
                class="password-icon-wrapper"
                >
                <b-icon
                font-scale="1.5"
                :icon="passwordType === 'password' ? 'eye-fill': 'eye-slash-fill'"
                 />
                </b-input-group-prepend>
              </b-input-group>
              <b-form-group>
                <BtnMain
                @btnClicked="handleLogin"
                text="Login"
                btnClass="login-btn mt-4"
                variant="success" 
              />
              </b-form-group>
              <b-form-group>
                <b-alert v-if="loginError"
                  show 
                  variant="danger"
                >
                  <p>{{ errorMsg }}</p>
                </b-alert>
              </b-form-group>
            </b-form>
            <div>
              <!-- <p>If you do not currently have an account  <b class="express-vue-temp a" @click="$router.push('register')">Click here to register</b></p>
              <p>Forgotten your password? <b class="express-vue-temp a" @click="$router.push('password-reset')">Click here to reset</b></p> -->
              <p>If you do not currently have an account <a href="javascript:;" @click="$router.push('register')" target="_self"> Click here to register </a></p>
              <p>Forgotten your password? <a href="javascript:;"  @click="$router.push('password-reset')" target="_self"> Click here to reset</a></p>
              <!-- <p>Need to update your registration details? <a href="javascript:;"  @click="$router.push('registration-update')" target="_self"> Click here to update</a></p> -->
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import BtnMain from '../components/BtnMain'
import { mapActions } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'

export default {
  components: {
    BtnMain
  },
  data () {
    return {
      user: {
        email: '',
        password: ''
      },
      loginError: '',
      errorMsg: '',
      passwordType: 'password'
    }
  },
  methods: {
    ...mapActions({
      loginAction: 'authStore/loginAction',
      setRecruitAction: 'authStore/setRecruitAction'
    }),
    async handleLogin () {
      // Check fields are valid before submission attempt
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loginError = false
        const res = await this.loginAction(this.user)
        if (!res) {  
          this.loginError = true
          this.errorMsg = 'There was an error logging you in. Please check your email and password or click the register link below if you do not have an account.'
          setTimeout(() => {
            this.loginError = false
            this.errorMsg = ''
          }, 5000)
        }
        // this.setRecruitAction(res)
      } else {
        this.loginError = true
        this.errorMsg = 'Please ensure you have entered both an email and password'
        setTimeout(() => {
            this.loginError = false
            this.errorMsg = ''
        }, 5000)
      }
    },
  toggleShowPassword(){
    this.passwordType === 'password'? this.passwordType = 'text' : this.passwordType = 'password'
  },
  },
  validations: {
    user: {
      email: {
        required: required,
        email: email
      },
      password: {
        required: required
      }
    }
  }
}
</script>

<style scoped>
.input-label{
  font-weight: 500;
}
.password-input{
  border-right: none;
}
.password-icon-wrapper > *{
  background-color: white;
}
.password-icon-wrapper > *:hover{
  color: green;
  cursor: pointer;
}
</style>